import { jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { memo } from "react";
import { IseeCardTitle } from "./components/isee-title.es.js";
import { IseeCardContent } from "./components/isee-content.es.js";
import { DualGridCardLayout } from "../../layouts/dual-grid-card-layout/dual-grid-card-layout.es.js";
function generateIseeCard({
  certificatedIseeValue,
  simulatedIseeValue,
  certificatedIseeIcon,
  simulatedIseeIcon,
  simulatedIseeTitle = "Valore ISEE simulato",
  certificatedIseeTitle = "Valore ISEE certificato",
  currentTitle = "Corrente",
  ordinaryTitle = "Ordinario",
  currency = "€",
  ...rest
}) {
  const startElement = {
    titleContent: /* @__PURE__ */ jsx(IseeCardTitle, { title: certificatedIseeTitle, icon: certificatedIseeIcon }),
    startContent: /* @__PURE__ */ jsx(IseeCardContent, { title: ordinaryTitle, value: certificatedIseeValue.ordinary, currency }),
    endContent: /* @__PURE__ */ jsx(IseeCardContent, { title: currentTitle, value: certificatedIseeValue.current, currency })
  };
  const endElement = {
    titleContent: /* @__PURE__ */ jsx(IseeCardTitle, { title: simulatedIseeTitle, icon: simulatedIseeIcon }),
    startContent: /* @__PURE__ */ jsx(IseeCardContent, { title: ordinaryTitle, value: simulatedIseeValue.ordinary, currency }),
    endContent: /* @__PURE__ */ jsx(IseeCardContent, { title: currentTitle, value: simulatedIseeValue.current, currency })
  };
  return /* @__PURE__ */ jsx(DualGridCardLayout, { startElement, endElement, ...rest });
}
const IseeCard = memo(generateIseeCard);
export {
  IseeCard
};
//# sourceMappingURL=isee-card.es.js.map
